var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99634 7.99832H21.0038",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49909 12H6.99805",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99925 18.0025H5.99759C4.34004 18.0025 2.99634 16.6588 2.99634 15.0013V6.99792C2.99634 5.34038 4.34004 3.99667 5.99759 3.99667H18.0026C19.6601 3.99667 21.0038 5.34038 21.0038 6.99792V10.9996",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4287 17.6353C13.4287 19.236 15.6776 20.4365 16.7111 20.8947C17.0323 21.0397 17.4003 21.0397 17.7215 20.8947C18.7549 20.4315 21.0039 19.242 21.0039 17.6353V15.0603C21.0034 14.5285 20.6697 14.0541 20.1695 13.8738L18.2417 13.1795C17.5783 12.9404 16.8523 12.9404 16.1889 13.1795L14.2631 13.8728C13.7623 14.053 13.4285 14.5281 13.4287 15.0603V17.6353Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/paymentIcon.afe69abb8d76be937c02b15338d81470.svg";
export { ForwardRef as ReactComponent };